import { DialogDescription, DialogTitle } from '@radix-ui/react-dialog';
import React, { useEffect, useState } from 'react';

import { Button } from '@/components/button';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { UserMessage } from '@/components/ui/user-message';
import { SavedItemModel } from '@/lib/models/saved-item/types';

export interface TabsDeleteDialogProps {
  isOpen: boolean;
  onOpenChange: (value: boolean) => void;
  onConfirm: () => void;
  onCancel: () => void;
  item?: SavedItemModel;
}

const TabsDeleteDialog = ({ isOpen, onOpenChange, onConfirm, onCancel, item }: TabsDeleteDialogProps) => {
  const [error, setError] = useState<string>();
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    setIsLoading(true);
    setError(undefined);

    try {
      await onConfirm();
    } catch (e: any) {
      setError(e.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!isOpen) {
      setError(undefined);
    }
  }, [isOpen]);

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent onClose={() => onOpenChange(false)}>
        <DialogTitle className="mb-2 text-md font-medium leading-snug">Are you sure?</DialogTitle>
        <DialogDescription>This will permanently delete the {item?.label} view</DialogDescription>
        {error ? <UserMessage className="!mb-2 !mt-0" heading={error} body="Please try again" variant="error" /> : null}
        <div className="ml-auto flex justify-end gap-2">
          <Button variant="primaryLightOutline" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="error" onClick={handleConfirm} disabled={isLoading} isLoading={isLoading}>
            Confirm
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export { TabsDeleteDialog };
